/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリーステストメール送信先
 * @export
 * @interface PressReleaseTestEmailAddress
 */
export interface PressReleaseTestEmailAddress {
    /**
     * 送信先宛名
     * @type {string}
     * @memberof PressReleaseTestEmailAddress
     */
    userName: string;
    /**
     * 送信先アドレス
     * @type {string}
     * @memberof PressReleaseTestEmailAddress
     */
    emailAddress: string;
}

export function PressReleaseTestEmailAddressFromJSON(json: any): PressReleaseTestEmailAddress {
    return PressReleaseTestEmailAddressFromJSONTyped(json, false);
}

export function PressReleaseTestEmailAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseTestEmailAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userName': json['user_name'],
        'emailAddress': json['email_address'],
    };
}

export function PressReleaseTestEmailAddressToJSON(value?: PressReleaseTestEmailAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_name': value.userName,
        'email_address': value.emailAddress,
    };
}

